import { TableColumnConfig, TableTabConfig } from "../../config/tableConfig.types";

export const executionEntityName = "dwautomationexecution";

const columns: TableColumnConfig[] = [
  {
    key: "statusLabel",
    label: "Status",
    width: 160,
    display: "badge",
    variantKey: "statusVariant",
  },
  {
    key: "modeLabel",
    label: "Mode",
    width: 100,
    display: "badge",
    variantKey: "modeVariant",
  },
  { key: "dueAt", label: "Send", width: 180, sortable: true, display: "datetime" },
  {
    key: "processingWindowStartsAt",
    label: "Processing Starts",
    width: 180,
    sortable: true,
    display: "datetime",
  },
  {
    key: "completedOn",
    label: "Completed",
    width: 180,
    sortable: true,
    display: "datetime",
  },
  {
    key: "fixtureName",
    label: "Fixture",
    width: 200,
    link: { to: "/fixture", idKey: "fixtureId", newTab: "button" },
  },
  {
    key: "communicationName",
    label: "Communication",
    width: 220,
    link: { to: "/email-communication", idKey: "communicationId", newTab: "button" },
  },
  {
    key: "audienceName",
    label: "Audience",
    width: 200,
    link: { to: "/audience", idKey: "audienceId", newTab: "button" },
  },
  { key: "emailsSentText", label: "Emails sent", width: 120 },
  { key: "openRateText", label: "Open rate", width: 110 },
  { key: "clickRateText", label: "Click rate", width: 110 },
  { key: "clicksToOpenRateText", label: "CTO", width: 90 },
  { key: "lastError", label: "Message", width: 480 },
];

const tab = (
  id: string,
  label: string,
  hide: string,
  dir: "asc" | "desc"
): TableTabConfig => ({
  id,
  label,
  entityName: executionEntityName,
  columns,
  flush: true,
  // On a new automation the tables are there, empty, rather than the card being bare.
  showWhenNew: true,
  // The rows carry which of the two tabs they belong on, so each hides the other's.
  exclude: { key: "phase", equals: hide },
  sort: { primary: { key: "dueAt", dir } },
  emptyMessage: "No executions.",
});

export const automationExecutionTabs: TableTabConfig[] = [
  tab("tab-upcoming", "Upcoming", "completed", "asc"),
  tab("tab-completed", "Completed", "upcoming", "desc"),
];
